import React from 'react'
import { Icon, Button } from 'semantic-ui-react'
import firebase from 'firebase/app'
import utils from '../../../../../utils'

export default class ReOrderButton extends React.PureComponent {
  state = {
    reordering: false,
  }

  reOrderingOrder = async () => {
    const { order } = this.props

    try {
      await this.setState({ reordering: true }, () => {})

      const params = {
        orderUid: order.key,
        branchUid: order.restaurant.branch.key,
      }

      const functions = firebase
        .app()
        .functions('asia-northeast1')
        .httpsCallable('orderAction')

      await functions({ actionType: 're-order', ...params })
    } catch (error) {
      await this.setState({ reordering: false }, () => {})
      alert(error.message || error)
    }
  }

  onReOrderClick = () => {
    const { order } = this.props
    const orderNumber = utils.order.getOrderNumber(order)

    const conf = window.confirm(`Are you sure to reorder ${orderNumber}?`)

    if (conf) {
      this.reOrderingOrder()
    }
  }

  render() {
    const { reordering, readOnly } = this.state
    const { order } = this.props
    const { voucher } = order

    const isOnlinePayment = order.payment_gateway

    return (
      <Button
        size="mini"
        loading={reordering}
        onClick={this.onReOrderClick}
        style={{ width: 150, margin: '5px 0px 0px 0px' }}
        disabled={reordering || readOnly || voucher || isOnlinePayment}
      >
        <Icon name="repeat" />
        Re-Order
      </Button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderListItem/ActionButtons/ReOrder.js